var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCookiesIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53.101,
    height: 53.227,
    viewBox: "0 0 53.101 53.227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cookies_icon",
    "data-name": "cookies icon",
    transform: "translate(11446.984 5759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61825",
    "data-name": "Path 61825",
    d: "M166.74,123.226a26.613,26.613,0,1,1,9.143-51.613,2.218,2.218,0,0,1,1.449,2.253c-.029.371-.059.744-.059,1.123A14.394,14.394,0,0,0,188.06,88.921a2.217,2.217,0,0,1,1.63,1.78,14.379,14.379,0,0,0,3.053,6.736,2.218,2.218,0,0,1,.495,1.608,26.469,26.469,0,0,1-26.5,24.18Zm0-48.791A22.178,22.178,0,1,0,188.727,99.5a18.8,18.8,0,0,1-3.126-6.686,18.83,18.83,0,0,1-12.762-17.526,22.154,22.154,0,0,0-6.1-.849Z",
    transform: "translate(-11587.13 -5829)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61826",
    "data-name": "Path 61826",
    d: "M383.659,356.133c4.282,0,4.288-6.653,0-6.653S379.371,356.133,383.659,356.133Z",
    transform: "translate(-11796.975 -6073.062)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61827",
    "data-name": "Path 61827",
    d: "M214.609,207.383c4.282,0,4.288-6.653,0-6.653S210.321,207.383,214.609,207.383Z",
    transform: "translate(-11649.349 -5943.163)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61828",
    "data-name": "Path 61828",
    d: "M322.069,182.173c4.282,0,4.288-6.653,0-6.653S317.781,182.173,322.069,182.173Z",
    transform: "translate(-11743.189 -5921.147)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61829",
    "data-name": "Path 61829",
    d: "M428.989,272.833c4.282,0,4.288-6.653,0-6.653S424.7,272.833,428.989,272.833Z",
    transform: "translate(-11836.56 -6000.318)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61830",
    "data-name": "Path 61830",
    d: "M249.789,340.553c4.282,0,4.288-6.653,0-6.653S245.5,340.553,249.789,340.553Z",
    transform: "translate(-11680.07 -6059.456)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookiesIconWhite);
export default __webpack_public_path__ + "static/media/cookies-icon-white.8f5dc96fc63e6634d313d9ba8f4806e5.svg";
export { ForwardRef as ReactComponent };